import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import lotService from "../../services/lot-service";
import lineService from "../../services/line-service";
import palmService from "../../services/palm-service";
import { ToastContainer, toast } from 'react-toastify';



import { Divider, message, Spin, Upload } from "antd";
import Dragger from "antd/es/upload/Dragger";
import { UploadProps } from "antd";
import moment from "moment";
import axios from "axios";
import fileService from "../../services/file-service";
import { URL_BASE } from "../../config/url-server";
import { height } from "@mui/system";

const InsertLinesExcel = () => {


  const [showDiv, setShowDiv] = useState(false);
  const [showDivPalms, setShowDivPalms] = useState(false);
  const [listLines, setListLines] = useState([]);
  const [lineName, setLineName] = useState("");
  const [listPalms, setListPalms] = useState([]);

  const { Dragger } = Upload;
  const [file, setFile] = useState("NOK");
  const [loading, setLoading] = useState(false);
  const [loadingPalm, setLoadingPalm] = useState(false);
  const [fileList, setFileList] = useState([]);

  const [lotId, setLotId] = useState("")
  const [title, setTitle] = useState("")


  const [listLots, setListLots] = useState([]);
  const [showSave, setShowSave] = useState(true);

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();





  const toUpperFieldName = (e) => {
    let value = e.target.value;
    setValue("name", value.toUpperCase());
  };

  ////FUNCIONES QUE USAN EL SERVICIO LOTSERVICE
  ////FUNCIONES QUE USAN EL SERVICIO LOTSERVICE

  const getListByLine = async (line) => {
    setLoadingPalm(true)
    setLineName(line.name)
    const listado = await palmService.getListByLine(line._id);
    const quantity = listado.length + 1;
    setValue("name", quantity);
    setListPalms(listado);
    setShowDiv(false)
    setShowDivPalms(true)
    setLoadingPalm(false)
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const getListLines = async (lotId) => {
    const listado = await lineService.getList(lotId);
    if (listado) {
      if (listado.length > 0) {
        setListLines(listado);
        setShowDivPalms(true)
      }
    }

    if (listado) {

      if (listado.length > 0) {
        const sortedList = [...listado].sort((a, b) => {
        const numA = parseInt(a.name);
        const numB = parseInt(b.name);
          return numA - numB;
        });

        setListLines(sortedList);
        setShowDivPalms(true)
      }
    }

  };




  const customSubmit = async (data) => {
    setLoading(true)
    const result = await fileService.createLinesPalmsExcel(data);
    setLoading(false)
    if (result) {
      const success = result.data.success;
      const message = result.data.message;
      if (success) {
        //message.success(result.data.message);
        toast(<div>
          {
            message.split('\n').map((line, index) => (
              <span key={index}>
                {line}
                <br />
              </span>
            ))}
        </div>, { autoClose: 2500 });
        setFile("");
        setFileList([]);
        setValue("document", "");
        getListLines(lotId)
        setShowDivPalms(true)
      } else {

        toast.error(result.data.message, {
          autoClose: false,
          onClick: () => {
            toast.dismiss();
          }
        });

      }
    }
  };



  const verifyTitle = (fileName) => {
    let message = ""
    let lot_name = localStorage.getItem("lotName");
    fileName = fileName.toUpperCase()
    lot_name = lot_name.toUpperCase()
    let result = fileName.includes("lot_name");
    if (!fileName.includes(lot_name)) {
      return "Titulo del excel no contiene: " + lot_name;
    }
    if (!fileName.includes("GEO")) {
      return "Titulo del excel no contiene la palabra: GEO ";
    }
    return "OK"
  }


  const props = {
    name: "file",
    height: "100px",
    multiple: false,
    fileList: fileList,
    accept: ".xlsx",
    maxCount: 1,
    action: URL_BASE + "file/upload",

    onChange(info) {


      const pin = getValues("pin")
      if (pin != "2525") {
        toast.error('Usuario sin privilegios!', { autoClose: 1000 });
        return;
      }


      /* const username = localStorage.getItem("username");
       if (username != "superadmin") {
         toast.error('Usuario sin privilegios!', { autoClose: 1000 });
         return;
       }*/



      const res = verifyTitle(info.file.name)
      if (res != "OK") {
        toast.error(res, {
          autoClose: false,
          onClick: () => {
            toast.dismiss();
          }
        });
        return
      }



      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        const response = info.file.response;
        if (response && response.status === "success") {
          const { originalname, filename, path, size } = response.file;
          //message.success(`${originalname} subido exitosamente.`);
          toast(`${originalname} subido exitosamente.`, { autoClose: 1000 });
          setFile(filename);
          setValue("document", filename);
        } else {
          toast.error("Error en la respuesta del servidor.");
        }
        // message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {

        toast.error(`${info.file.name} file upload failed.`);
      }

      setFileList(info.fileList);
    },
    onRemove: async (e) => {

      try {
        const response = await axios.delete(
          `https://core.palmicultor.com.co/api/file/delete/${file}`
        );
        if (response.data.status === "success") {
          setFile("");
          setFileList([]);
          setValue("document", "");
        } else {
          console.error("Error al eliminar el archivo:", response.data.message);
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
      }
    },
  };


  const getLot = async (lotId) => {
    const lot = await lotService.getLot(lotId);
    if (lot) {
      setValue("farmId", lot.farmId);
      setValue("farmName", lot.farmName);
      setValue("sectionId", lot.sectionId);
      setValue("sectionName", lot.sectionName);
      setValue("lotId", lot._id);
      setValue("lotName", lot.name);
      setShowSave(false);
    }
  };






  useEffect(() => {
    const lot_id = localStorage.getItem("lotId");
    setLotId(lot_id)
    getLot(lot_id);
    getListLines(lot_id)
    const farm_name = localStorage.getItem("farmName");
    const lot_name = localStorage.getItem("lotName");
    setTitle(`Finca: ${farm_name} - ${lot_name}`);

    const username = localStorage.getItem("username");
    if (username == "superadmin") {
      setValue("pin", "2525")
    }
    
  }, []);


  return (
    <div className="row p-4">

      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Ingreso de lineas desde Excel  - {title}  </Divider>
      </div>



      <div className="col-12 ms-2">
        <Link to="/admin-lots" className="nav-link link-primary p-1">
          <i className="bi bi-arrow-left-short fa-lg"></i>
          <span className="fs-6 m-1">
            <strong>REGRESAR A LA FINCA</strong>
          </span>
        </Link>
      </div>

      <div className="col-12 col-sm-4">
        <div className="card p-4">
          <form className="form-react" onSubmit={handleSubmit(customSubmit)}>
            <div className="row">
              <div className="card-title">
                <h4>Ingresar lineas del lote</h4>
              </div>

              <ToastContainer />

              <div className=" col-12 d-none">
                <label>Id lote</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("lotId")}
                />
              </div>

              <div className=" col-12 d-none">
                <label>Id Finca</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("farmId")}
                />
              </div>

              <div className=" col-6 col-sm-6">
                <label>Finca</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("farmName")}
                />
              </div>



              <div className=" col-6 d-none">
                <label>Id Seccion</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("sectionId")}
                />
              </div>


              <div className=" col-12 col-sm-6">
                <label>Seccion</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("sectionName")}
                />
              </div>

              <div className=" col-12 col-sm-6">
                <label>Lote</label>
                <input
                  type="text"
                  readOnly={true}
                  onKeyUp={toUpperFieldName}
                  className="form-control bg-light"
                  {...register("lotName")}
                />
              </div>



              <div className=" col-6">
                <label>PIN</label>
                <input
                  type="password"
                  className="form-control bg-light"
                  {...register("pin")}
                />
              </div>



              <div className=" col-12 mt-1 d-none">
                <label>Document</label>
                <input
                  type="text"
                  readOnly={true}
                  onKeyUp={toUpperFieldName}
                  className="form-control bg-light"
                  {...register("document", { required: true, minLength: 3 })}
                />
                {errors.name?.type === "required" && (
                  <small className="text-danger">Campo requerido</small>
                )}
                {errors.name?.type === "minLength" && (
                  <small className="text-danger">Minimo 15 caracteres</small>
                )}
              </div>

              <div className="col-12 mt-4" style={{ height: '130px' }}>
                <div className="row">
                  <div className="col-12">
                    <Dragger {...props}>
                      <p className="ant-upload-drag-icon"></p>
                      <p className="ant-upload-text">
                        Click o arrastre para subir
                      </p>
                      <p className="ant-upload-hint">
                        Solo se aceptan archivos con extensión xlsx.
                      </p>
                    </Dragger>
                  </div>
                </div>
              </div>

              <div className="  col-12 col-sm-6">
                <label>&nbsp; </label>
                <Spin spinning={loading}>
                  <button className="btn btn-primary w-100" type="submit">
                    <i className="bi bi-save fa-lg m-2" /> Guardar
                  </button>
                </Spin>
              </div>
            </div>
          </form>
        </div>
      </div>




      <div className={showDivPalms ? "col-12 col-sm-4" : "d-none"}>
        <div className="card p-4">
          <div className="card-title">
            <h4 className="text-secondary" >Listado de líneas</h4>
            <div className=" bdr">
              <table className="table">
                <thead className="table-primary">
                  <tr>
                    <th>Nombre</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {listLines.map((line) => (
                    <tr key={line._id}>
                      <td>{line.name}</td>
                      <td style={{ width: "110px" }}>
                        <button
                          className="btn btn-primary ms-2"
                          onClick={() => getListByLine(line)}
                        >
                          <i className="bi bi-search fa-lg m-1" /> palmas
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>



      <div className={showDivPalms ? "col-12 col-sm-4" : "d-none"}>
        <div className="card p-4">
          <div className="card-title">
            <h4 className="text-secondary" >Palmas línea {lineName}</h4>
            <div className=" bdr">
              <Spin spinning={loadingPalm}>
                <table className="table">
                  <thead className="table-primary">
                    <tr>
                      <th>Nombre</th>
                      <th>Latitud</th>
                      <th>Longitud</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listPalms.map((palm) => (
                      <tr key={palm._id}>
                        <td>{palm.name}</td>
                        <td>{palm.latitude}</td>
                        <td>{palm.longitude}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Spin>
            </div>
          </div>
        </div>
      </div>








    </div>
  );
};

export default InsertLinesExcel;
